// src/components/features/timetables/TimetablesTab/SearchForm.tsx
import { Button } from '../../../base/Button/Button';
import { Input } from '../../../base/Input/Input';
import { StateMessage } from '../../../base/StateMessage/StateMessage';
import styles from './TimetableSearchForm.module.css';

interface TimetableSearchFormProps {
  query: string;
  onQueryChange: (value: string) => void;
  onSearch: (event: Event) => void;
  submitError: string | null;
  loading: boolean;
  hasSubmitted: boolean;
}

export function TimetableSearchForm({
  query,
  onQueryChange,
  onSearch,
  submitError,
  loading,
  hasSubmitted,
}: TimetableSearchFormProps) {
  return (
    <>
      <form className={styles.form} onSubmit={onSearch}>
        <Input
          label="Enter a bus name, operator or location"
          hint="Try combining search terms to narrow down your search"
          placeholder="e.g. X1 Newcastle"
          value={query}
          onInput={(event) => onQueryChange(event.currentTarget.value)}
        />
        <Button
          fullWidth={true}
          type="submit"
          loading={hasSubmitted && loading}
        >
          Search
        </Button>
      </form>

      {submitError && (
        <StateMessage
          state="error"
          title="Missing search text"
          message={submitError}
        />
      )}
    </>
  );
}
